import { computed, makeObservable, observable } from 'mobx'
import { JobTaxAssistantDTO } from './dtos/job-tax-assistant'
import { Model } from 'infra/model'
import { maybeParseDate } from 'utils/date-util'
import Message from 'messaging/models/Message'

type JobTaxAssistantReplyStatus = 'IDLE' | 'PROCESSING'

export default class JobTaxAssistant extends Model<
  JobTaxAssistantDTO,
  JobTaxAssistant
> {
  jobId: string = ''
  replyStatus: JobTaxAssistantReplyStatus = 'IDLE'
  active = false
  externalReplyId: string | undefined = undefined
  dateModified: Date | undefined = undefined

  constructor() {
    super()
    makeObservable(this, {
      jobId: observable,
      replyStatus: observable,
      active: observable,
      externalReplyId: observable,
      dateModified: observable,
      isTyping: computed,
    })
  }

  get displayName() {
    return 'Luis AI'
  }

  get avatar() {
    return require('assets/images/img_luis.svg')
  }

  get isTyping() {
    return this.replyStatus === 'PROCESSING'
  }

  isDepartingConversationMessage(message: Message) {
    return (
      !this.active &&
      message.content.type === 'Assistant' &&
      this.externalReplyId === message.content.externalReplyId
    )
  }

  parse(json: JobTaxAssistantDTO): Partial<JobTaxAssistant> {
    return {
      jobId: json.job_id,
      replyStatus: json.reply_status,
      externalReplyId: json.external_reply_id,
      active: json.active,
      dateModified: maybeParseDate(json.update_time),
    }
  }
}
